import React from 'react';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import { isCordova } from 'utils/platform';

const AppPromo = Load(() => import(/* webpackChunkName: "app-page" */'./components/AppPromoPage'), {}, true);

const AppPromoRoute = (
  <NavigationableLayout
    key={'app-promo'}
    path={`${basePath}/app`}
    component={AppPromo}
    noNavbar={isCordova()}
    showBottomNavigation
  />
);

export default AppPromoRoute;
